exports.components = {
  "component---src-pages-account-tsx": () => import("./../../../src/pages/account.tsx" /* webpackChunkName: "component---src-pages-account-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-manage-serials-tsx": () => import("./../../../src/pages/manage/serials.tsx" /* webpackChunkName: "component---src-pages-manage-serials-tsx" */)
}

